import { ActionContext } from 'vuex';

import { getLocalState } from '@/common/utils/store';

import UserApi from '../../api/users';
import { USERS_MUTATIONS_NAME } from './name';
import { TUsersStoreState } from './types';

export async function getUsers(context: ActionContext<TUsersStoreState, unknown>) {
  const response = await UserApi.searchUserOptions();
  context.commit(getLocalState(USERS_MUTATIONS_NAME.setUsers), response);
}
